// Instalaciones que inspecciona la bitácora: el canopy, el Tarzan Swing y el Canyoning.
// Cada inspección, marca de "sin operación" y paquete de auditoría pertenece a
// una instalación (columna `instalacion` en vlsdb; null en cables_reportes =
// todas). Una fila sin la columna (base todavía sin migrar) es del canopy.
//
// El checklist de cada instalación vive en data/checklist.js (lo mantiene el
// asistente). Si ese archivo exporta getChecklist(instalacion), se usa; si no,
// el canopy toma ITEMS/SECCIONES de siempre y el resto queda "pendiente de
// definir" (sin ofrecer Nueva inspección ni enlaces muertos).
import * as checklist from 'data/checklist';

export const INSTALACIONES = [
  { id: 'canopy', label: 'Canopy', titulo: 'Inspección diaria de canopy' },
  { id: 'tarzan_swing', label: 'Tarzan Swing', titulo: 'Inspección diaria del Tarzan Swing' },
  { id: 'canyoning', label: 'Canyoning', titulo: 'Inspección diaria del Canyoning' },
];

export const INSTALACION_POR_DEFECTO = 'canopy';
// Texto cuando el checklist de una instalación está cargado pero marcado
// `pendiente` (propuesta en validación con el inspector): se puede ver, pero
// no se ofrece Nueva inspección.
export const TEXTO_CHECKLIST_PENDIENTE = 'Checklist en validación';

const POR_ID = Object.fromEntries(INSTALACIONES.map((i) => [i.id, i]));

export const instalacionValida = (id) => Object.prototype.hasOwnProperty.call(POR_ID, id);

// Valor de la URL (?instalacion=) a uno válido; cualquier otro cae en canopy.
export const normalizarInstalacion = (id) => (instalacionValida(id) ? id : INSTALACION_POR_DEFECTO);

export const etiquetaInstalacion = (id) => POR_ID[normalizarInstalacion(id)].label;
export const tituloInstalacion = (id) => POR_ID[normalizarInstalacion(id)].titulo;

// Instalación de una fila: la columna, o canopy si la base todavía no la tiene.
export const instalacionDe = (fila) => normalizarInstalacion(fila?.instalacion || INSTALACION_POR_DEFECTO);

export const filtrarPorInstalacion = (filas, instalacion) =>
  (filas || []).filter((f) => instalacionDe(f) === normalizarInstalacion(instalacion));

// { items, secciones, pendiente } del checklist de la instalación, o null si
// no hay ninguno cargado. Acepta que getChecklist devuelva { ITEMS, SECCIONES,
// pendiente }, { items, secciones, pendiente } o directamente la lista.
export function checklistDe(instalacion) {
  const inst = normalizarInstalacion(instalacion);
  if (typeof checklist.getChecklist === 'function') {
    let c = null;
    try { c = checklist.getChecklist(inst); } catch { c = null; }
    if (Array.isArray(c) && c.length) {
      return { items: c, secciones: [{ id: inst, titulo: 'Checklist', items: c }], pendiente: false };
    }
    const items = c?.ITEMS || c?.items;
    if (Array.isArray(items) && items.length) {
      const secciones = c.SECCIONES || c.secciones || [{ id: inst, titulo: 'Checklist', items }];
      return { items, secciones, pendiente: !!c.pendiente };
    }
    if (inst !== 'canopy') return null;
  }
  if (inst === 'canopy') return { items: checklist.ITEMS || [], secciones: checklist.SECCIONES || [], pendiente: false };
  return null;
}

// Se puede registrar una inspección nueva: checklist cargado y no en validación.
export const checklistVigente = (instalacion) => {
  const c = checklistDe(instalacion);
  return !!c && !c.pendiente;
};

// Etiquetas { clave: label } del checklist de una instalación (vacío si no
// está definido: la pantalla muestra la clave tal cual).
export const etiquetasDe = (instalacion) =>
  Object.fromEntries((checklistDe(instalacion)?.items || []).map((i) => [i.key, i.label]));
